<template>
  <div class="signinform">
    <div>Hey, Let's get you in</div>
    <div v-if="loading" class="loading-indicator">Working...</div>
    <form  @submit="login" method="post">
      <div class="row">
        <div v-if="output" class="col-md-12">
          <div class="alert alert-warning" role="alert">{{ output }}</div>
        </div>

        <div class="col-md-12">
          <input type="text" name="phone"  class="form-control" v-model="loginFields.phone" placeholder="Phone Number" />
        </div>
        <div class="col-md-12">
          <input type="password" name="password" class="form-control" v-model="loginFields.password" placeholder="Password" />
        </div>
        <div class="col-md-12">
          <button type="submit" class="btn btn-info" >Sign In</button>
        </div>
      </div>
    <div>
      Don't have an account?  <router-link to="/signup">Sign Up</router-link> | <router-link to="/">Cancel</router-link> 
    </div>
    </form>
  </div>
</template>
<script>
import { backendUrl } from '../config';
import axios from 'axios'
export default {
  name: 'Signin',
  data() {
    return {
      loading: false,
      output:null,
      loginFields: {
        phone: "",
        password: ""
      }
    }
  },
  methods: {
    login(e) {
      let obj = this
      obj.loading = true
      obj.output = null
       const headers = {
        'Content-Type': 'application/x-www-form-urlencoded',
      }

      axios({
          method: 'post',
          url: backendUrl+'login',
          params: this.loginFields,
          headers: headers
      })
      .then(function (response) {
        if(response.data.success == 1){
          obj.$store.commit("setAuthentication", true)
          obj.$store.commit("setUser", response.data.more)
          obj.$router.replace({ name: "Inbox" })
        } else {
          obj.output = response.data.message
          obj.loading = false
        }
        console.log(response);
        
      })
      .catch(function (error) {
          console.log(error);
      });
      e.preventDefault()
    }
  }
}
</script>

<style scoped>
input, button {
  width:100%;
  display:block;
}
.signinform{
  width:25em;
  margin: 3em auto;
  text-align:center;
  background: #fafafa;
  padding: 1em;
}
.signinform div{
 margin: 1em 0;
}
a {
  color: #42b983;
}
</style>
